import {Component, Input} from "@angular/core";
import {CirfUdf} from "../../cirf/cirf-udf";
import {FormGroup} from "@angular/forms";

@Component({
    selector    : 'dp-cirf-udf',
    templateUrl : './cirf-udf.component.html',
})

export class CirfUdfComponent {

    @Input() formGroup: FormGroup;
    @Input() cirfFormArrayName: string;
    @Input() cirfUdfFieldKey: string;
    @Input() cirfUdfs: CirfUdf[];

}